<section class="material-half-bg">
        <div class="cover">
            <header>
                  <div class="col-lg-7 pull-left">
                    <a href="javascript::">
                      <img src="assets/images/admin-logo.png">
                      <div class="">
                        <h4 id="name">UNIVERSITY OF MINES AND TECHNOLOGY</h4>
                        <h4><strong>ADMISSIONS PORTAL</strong></h4>
                      </div>



                  </a>
                  </div>

                  <div class="rigid col-md-4">
                    <nav>
                      <ul class="meta">
                      <!-- <li><small><a href="http://knust.edu.gh/about/contacts">Contact Us</a></small></li>
                      <li><small><a href="http://knust.edu.gh">KNUST Website</a></small></li>
                      <li><small><a href="http://apps.knust.edu.gh/admissions">Home</a></small></li> -->
                      </ul>
                    </nav>
                  </div>
                </header>
        </div>
      </section>
      <section class="login-content">
        <div class="logo">
          <!-- <h1 class="text-center">UMaT</h1>
          <h2>{{applicantType}}</h2> -->
        </div>
        <div class="login-box">

            <router-outlet></router-outlet>

        </div>
        <div class="text-center pt-3">
                <!-- <hr> -->
            <!-- <p class="text-muted">Developed by <a href="http://www.qfacegroup.com"> QFace Group GH.</a></p> -->
            </div>
      </section>
